import { memo, ReactNode } from "react"

export const ItemBackground = memo<{ className?: string; children?: ReactNode }>(({ children, className }) => (
  <div className={`min-h-[56px] w-full rounded-lg bg-gray-100 py-[10px] px-4 ${className ? className : ""}`}>{children}</div>
))
